<script>

    import layer from "@/mixins/mapboxLayer"

    export default{

        mixins:[layer],
        
        name:"ajrmarkers",

        data(){
            return {
                loadDelay:0,
                icons:{ajricon:"/images/ajr.png", 
                        // catedral:"/images/catedral.png",
                        // congresso:"/images/congresso.png",
                        // alvorada:"/images/alvorada.png",
                    },
            }
        },

        computed:{
            geoJSON:function(){

                return {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-47.90088246602883,-15.738488635512695]
                        },
                        "properties":{
                            opacityStops:[[11.3, 0], [11.4, 1]],
                            icon:"ajricon",
                            name:"AJR Sports",
                            description:" Phone XXX"
                        }
                    },
                    {
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-47.87551339959032,-15.7983599878431]
                        },
                        "properties":{
                            opacityStops:[[11.3, 0], [11.4, 1]],
                            icon:"catedral",
                            name:"Catedral",
                            description:" Phone XXX"
                        }
                    },
                     {
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-47.8641153017536,-15.799666707772914]
                        },
                        "properties":{
                            opacityStops:[[11.3, 0], [11.4, 1]],
                            icon:"congresso",
                            name:"Congresso",
                            description:" Phone XXX"
                        }
                    },
                    //  {
                    //     "type": "Feature",
                    //     "geometry": {
                    //         "type": "Point",
                    //         "coordinates": [-47.82183864958691,-15.792641248116936]
                    //     },
                    //     "properties":{
                    //         opacityStops:[[11.3, 0], [11.4, 1]],
                    //         icon:"alvorada",
                    //         name:"Alvorada",
                    //         description:" Phone XXX"
                    //     }
                    // }
                    ]
                }
            },
        },

        watch:{
            geoJSON:function(){
                // this.animatePoints(4, false)
            }
        },

        methods:{

        },

        style: function () {
            return {
                "type": "symbol",
                "layout": {
                    "icon-image": ["get", "icon"], //['case', ['==',['get','index'],0], 'largada','pis'],  //"pis",
                    "icon-anchor": "center",
                    "icon-allow-overlap": true,
                    "icon-size": {
                        "base": 1,
                        "stops": [
                            [8.9, 0.1],
                            [11, 0.5],
                            [14, 1.3]
                        ]
                    },
                },
                "paint": {
                    "icon-opacity": {
                        "base": 1,
                        "stops": [[11.3, 0], [11.4, 1]],
                    },
                }
            }
        }
    }


</script>